define(["data/config"], function(config) {
    var apply = function($form, params) {
        var $create = $form.find('.js_createAvailability');
        var $template = $('.js_availabilityForm-template');
        var $wrapper = $form.find('.js_availabilityForm-wrapper');
        var $n_items = $wrapper.find('.js_availabilityForm-item').length;

        $create.on('click', function($e) {
            $e.preventDefault();
            var $clone = $template.clone().children().first();
            $clone.appendTo($wrapper);
            $clone.find('[name^=slot]').each(function(i, e) { 
                var name = $(e).attr('name').replace(/\[i\]/, '['+$n_items+']');
                $(e).attr('name', name);
            });
            $n_items++;
        });

        $form.on('click', '.js_deleteAvailability', function($e) {
            $e.preventDefault();
            $($e.target).parents('.c_uiForm').first().remove();
            $n_items--;
        })
    };

    return {
        name: "availabilityForm",
        apply: apply
    };
});